var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconValesFisicos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-vales-fisicos",
    transform: "translate(0.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rect\\xE1ngulo_1883",
    "data-name": "Rect\\xE1ngulo 1883",
    transform: "translate(-0.135)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 40,
    height: 39,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    transform: "translate(3.362 3.254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Business"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coupon_line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "MingCute",
    d: "M34.61,0V33.492H0V0ZM18.161,32.456l-.017,0-.1.05-.027.005h0l-.022-.005-.1-.05a.031.031,0,0,0-.034.008l-.006.015-.025.6.007.028.016.017.149.1.021.005h0l.017-.005.149-.1L18.2,33.1h0l0-.023-.025-.6a.03.03,0,0,0-.023-.025Zm.382-.157-.02,0-.266.129-.014.014h0l0,.016.026.6.007.018h0l.012.01.29.129a.037.037,0,0,0,.041-.011l.006-.02-.049-.858a.036.036,0,0,0-.028-.03Zm-1.032,0a.034.034,0,0,0-.04.007l-.008.019-.049.858a.032.032,0,0,0,.024.033l.023,0,.29-.129.014-.011h0l.006-.016.026-.6,0-.018h0l-.014-.012Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6",
    d: "M27.686,4a4.6,4.6,0,0,1,4.525,4.411l.008.275v2.839A2.434,2.434,0,0,1,31.047,13.6l-.162.091a3.177,3.177,0,0,0-.21,5.491l.21.118a2.447,2.447,0,0,1,1.324,1.935l.011.232v2.839a4.623,4.623,0,0,1-4.267,4.679l-.266.008H6.533a4.6,4.6,0,0,1-4.525-4.411L2,24.308V21.47a2.434,2.434,0,0,1,1.172-2.077l.162-.091a3.177,3.177,0,0,0,.21-5.491l-.21-.118a2.447,2.447,0,0,1-1.324-1.935L2,11.525V8.687A4.623,4.623,0,0,1,6.267,4.008L6.533,4Zm0,3.124H6.533a1.53,1.53,0,0,0-1.5,1.38l-.01.182v2.4A6.362,6.362,0,0,1,5.3,21.732l-.28.178v2.4A1.545,1.545,0,0,0,6.357,25.86l.176.011H27.686a1.53,1.53,0,0,0,1.5-1.38l.01-.182v-2.4a6.362,6.362,0,0,1-.28-10.647l.28-.178v-2.4a1.545,1.545,0,0,0-1.335-1.552Zm-13.6,4.687a1.53,1.53,0,0,1,1.5,1.38l.01.182v6.249a1.509,1.509,0,0,1-3.012.182l-.01-.182V13.373A1.537,1.537,0,0,1,14.088,11.811Z",
    transform: "translate(0.195 0.249)",
    fill: "#777"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconValesFisicos);
export default __webpack_public_path__ + "static/media/icon-vales-fisicos.ad5c831ee5596318e15b56aea4bb747b.svg";
export { ForwardRef as ReactComponent };